module.exports = __webpack_public_path__ + "static/Admin-Page-2-d29c79eb2f7d886432164963f0d5099b.jpg";